import ModalContext from './ModalContext'

const ModalConsumer = ModalContext.Consumer

export default ModalConsumer